module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogined) ? _c('div', {
    staticClass: "invoiceContent"
  }, [_c('div', {
    staticClass: "deliverySaveBtn"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "添加"
    },
    on: {
      "click": _vm.add
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "deliveryInvoiceList"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.addList), function(item, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(item.invoiceHeader))]), _vm._v(" "), _c('td', [_c('el-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v(" " + _vm._s(item.invoiceTypeDisplay))])], 1), _vm._v(" "), _c('td', [_c('el-tag', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "type": "warning"
      }
    }, [_vm._v(" " + _vm._s(item.invoiceHeaderTypeDisplay))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dutyParagraph))]), _vm._v(" "), _c('td', [_c('div', [_c('span', {
      staticClass: "edit",
      on: {
        "click": function($event) {
          return _vm.edit(item)
        }
      }
    }, [_vm._v("修改")]), _vm._v("|"), _c('span', {
      staticClass: "del",
      on: {
        "click": function($event) {
          return _vm.del(item.id)
        }
      }
    }, [_vm._v("删除")])])])])
  })], 2)]), _vm._v(" "), _c('editInvoice', {
    ref: "editInvoice",
    on: {
      "fetch-data": _vm._invoiceList
    }
  })], 1) : _c('div', {
    staticClass: "invoiceContent1"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("亲,请先登陆")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "invoiceHead"
  }, [_c('th', {
    staticClass: "headName"
  }, [_vm._v("发票抬头")]), _vm._v(" "), _c('th', {
    staticClass: "invoiceHeadType"
  }, [_vm._v("发票类型")]), _vm._v(" "), _c('th', {
    staticClass: "invoiceHeadType1"
  }, [_vm._v("抬头类型")]), _vm._v(" "), _c('th', {
    staticClass: "dutyParagraph"
  }, [_vm._v("税号")]), _vm._v(" "), _c('th', [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9fd7ade","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/invoiceList.vue
// module id = 782
// module chunks = 2